import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';

import { Redirect } from 'react-router-dom';
import { PageSection } from 'adc-ui-components';

import { getIsCancelationRequired } from '../../../helpers/order';
import { chooseReasons } from '../../../actions/order';
import { RETURNS_RETURN_METHODS, RETURNS_SELECT_DEVICE } from '../../../helpers/routes';

import GoBack from '../../../components/GoBack';
import SelectedDevices from './SelectedDevices';

const cancelationRequiredMessage = (returnReasons) => {
  if (!getIsCancelationRequired(returnReasons)) return null;
  return (
    <div className="card-group">
      <div className="card card--warning">
        <div className="card__content">
          <p>
            {'If you haven\'t already, please contact us to confirm any change to your service.'}
          </p>
        </div>
      </div>
    </div>
  );
};

const troubleshootMessage = (selectedDevices, values) => {
  if (!values) {
    return '';
  }
  const selectedSerials = Object.keys(values);
  const troubleshootSerials = selectedSerials.filter(serial => values[serial] === '4|4');
  const troubleshootLobs = selectedDevices.reduce((acc, device) => {
    if (troubleshootSerials.indexOf(device.serialNumber) > -1) {
      acc.push(device.lob);
    }
    return acc;
  }, []);

  let troubleshootLink = 'https://www.xfinity.com/support/';

  if (troubleshootLobs.indexOf('internet') === -1) { // send to TV only troubleshoot
    troubleshootLink = 'https://www.xfinity.com/support/repair/tv';
  }

  if (troubleshootLobs.indexOf('video') === -1) { // send to internet only troubleshoot
    troubleshootLink = 'https://www.xfinity.com/support/repair/internet';
  }

  if (troubleshootLobs.indexOf('internet') > -1 || troubleshootLobs.indexOf('video') > -1) {
    return (
      <div className="card-group">
        <div className="card card--warning">
          <div className="card__content">
            <p>
              Before you return this equipment, have you tried troubleshooting?&nbsp;
              <a rel="noopener noreferrer" target="_blank" href={troubleshootLink}>Get Started</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return false;
};

const ReturnReason = ({
  handleChooseReasons,
  history,
  selectedDevices,
}) => {
  const submitReason = useCallback((values) => {
    handleChooseReasons(values);
    history.push(RETURNS_RETURN_METHODS);
  }, [history, handleChooseReasons]);

  if (!selectedDevices) {
    return <Redirect to={RETURNS_SELECT_DEVICE} />;
  }

  const initReturnReasons = selectedDevices.reduce((obj, device) => ({ ...obj, [device.serialNumber]: device.returnReason || '' }), {});

  return (
    <PageSection className="ui-grey">
      <h1 className="heading2">
        {'What\'s your reason for returning this equipment?'}
      </h1>
      <Formik
        initialValues={initReturnReasons}
        onSubmit={submitReason}
      >
        {({
          values,
        }) => {
          const returnReasons = Object.keys(values).map(serial => values[serial]);
          const troubleMsg = troubleshootMessage(selectedDevices, values);
          const cancelMsg = cancelationRequiredMessage(returnReasons);
          return (
            <Form>
              <div className={`card-group ${(troubleMsg || cancelMsg) && 'mb12'}`}>
                <div className="card-group__item">
                  <div className="card">
                    <div className="card__content">
                      <h3>{`Device${(selectedDevices.length > 1) ? 's' : ''} You're Returning`}</h3>
                    </div>
                  </div>
                </div>
                <SelectedDevices devices={selectedDevices} />
              </div>

              {cancelMsg}
              {troubleMsg}

              <div className="action action--right">
                <div className="action__item">
                  <button type="submit" className="button button--primary">Continue</button>
                </div>
                <div className="action__item">
                  <GoBack>Back</GoBack>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </PageSection>
  );
};

const mapStateToProps = state => ({
  selectedDevices: state.order.selectedDevices,
});

const mapDispatchToProps = {
  handleChooseReasons: chooseReasons,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnReason);
